const opportunityOption = {
  jobTargetStatusSource: {
    /**
     * @param that - is a reference to the Vue component, in this case CrudEnumPicker.vue
     */
    $isDisabled: function (that) {
      // we  split and get only first two parts of targetStatus rule
      // exp: precheck/admin=, hardware_sale/brand=
      const targetSourceSub = that.value.map((item) =>
        item.substring(0, item.lastIndexOf('=')),
      );
      // then we loop trough existing options and check if there are duplicates
      return that.enumValues.map((item) => {
        return that.value.includes(item)
          ? false
          : targetSourceSub.includes(
              item.toString().substring(0, item.toString().lastIndexOf('=')),
            );
      });
    },
  },
};

export default opportunityOption;
